var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"'height":"150px","width":"100%"}},[_c('canvas',{ref:"canvas",staticStyle:{"max-width":"100%","max-height":"100%"},attrs:{"height":"150","width":"718"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a99d077","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/tests/InBody/InBodyHorizontalBar.vue
// module id = nu3O
// module chunks = 0 1